module.exports = "<p class=\"app-message animate-show-hide ng-hide-animate\"\n   ng-class=\"{error: $ctrl.error, success: $ctrl.success, info: $ctrl.info, delay: $ctrl.delay}\"\n   ng-if=\"($ctrl.success || $ctrl.error || ($ctrl.info && $ctrl.info.message && !$ctrl.getConsent($ctrl.info.cookieKey)))\">\n   <span>{{ ($ctrl.error.message || $ctrl.success || $ctrl.info.message) | translate }}</span>\n   <a href=\"#\" ng-click=\"$ctrl.hide()\">x</a>\n</p>\n\n<pre ng-if=\"$ctrl.error\" style=\"display: none;\">{{$ctrl.error.cause}}</pre>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/app-message/app-message.html
// module id = 573
// module chunks = 0